import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined'
import StraightenIcon from '@mui/icons-material/Straighten'
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'

import { ReactComponent as Camera } from 'assets/exceptions/Camera.svg'
import { ReactComponent as Contamination } from 'assets/exceptions/Contamination.svg'
import { ReactComponent as Damage } from 'assets/exceptions/Damage.svg'
import { ReactComponent as Delay } from 'assets/exceptions/Delay.svg'
import { ReactComponent as Extra } from 'assets/exceptions/Extra.svg'
import { ReactComponent as Location } from 'assets/exceptions/Location.svg'
import { ReactComponent as NoAccess } from 'assets/exceptions/NoAccess.svg'
import { ReactComponent as NoPayment } from 'assets/exceptions/NoPayment.svg'
import { ReactComponent as Note } from 'assets/exceptions/Note.svg'
import { ReactComponent as NotOut } from 'assets/exceptions/NotOut.svg'
import { ReactComponent as Overloaded } from 'assets/exceptions/Overloaded.svg'
import { ReactComponent as Safety } from 'assets/exceptions/Safety.svg'
import { ReactComponent as SerialNumber } from 'assets/exceptions/SerialNumber.svg'
import { ReactComponent as ServiceReview } from 'assets/exceptions/ServiceReview.svg'
import { ReactComponent as Signature } from 'assets/exceptions/Signature.svg'
import { ReactComponent as Special } from 'assets/exceptions/Special.svg'
import { ReactComponent as Weight } from 'assets/exceptions/Weight.svg'

type ExceptionSvg = typeof NoAccess

export const exceptionNameToSvg: Record<string, ExceptionSvg> = {
  Contamination,
  Damage,
  Delay,
  Extra,
  'Extra Item': Extra,
  Location,
  'Set location': Location,
  'No Access': NoAccess,
  'No Payment': NoPayment,
  'Not Out': NotOut,
  Overloaded,
  Photo: Camera,
  Safety,
  'Service Review': ServiceReview,
  Special,
  Weight,
  Note,
  Sign: Signature,
  Camera,
  'Serial Number': SerialNumber,
}

// Color and Size have no SVG in assets/exceptions; they reuse the MUI glyphs the Review chips already render.
const exceptionNameToMuiIcon: Record<string, React.ComponentType<SvgIconProps>> = {
  Color: PaletteOutlinedIcon,
  Size: StraightenIcon,
}

type ExceptionIconProps = Omit<SvgIconProps, 'children'> & {
  exception?: string | null
}

const ExceptionIcon = ({ exception, sx, ...rest }: ExceptionIconProps) => {
  const MuiIcon = exception ? exceptionNameToMuiIcon[exception] : undefined
  const Icon = exception && exception in exceptionNameToSvg ? exceptionNameToSvg[exception] : NoAccess
  return (
    <Tooltip arrow placement="bottom" title={exception}>
      {MuiIcon ? (
        <MuiIcon sx={sx} {...rest} />
      ) : (
        <SvgIcon sx={sx} {...rest}>
          <Icon />
        </SvgIcon>
      )}
    </Tooltip>
  )
}

export default ExceptionIcon
